import React, { useState, useEffect } from "react";
import api, { baseURL } from "../api";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DeptDataYear = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const state = location.state || {};
  const { id } = state;
  const [activeIndex, setActiveIndex] = useState(null);
  const [data, setData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [departmentName, setDepartmentName] = useState([]);

  const fetchDeptData = async () => {
    try {
      const response = await api.get(`/department-datas?lang=${i18n.language}`);
      const filteredDepartments = response.data.filter(
        (department) =>
          department.status === 1 &&
          department.language_code === i18n.language
      );
      const filteredData = filteredDepartments.filter(
        (item) => String(item.y_id) === String(id)
      );
      setDeptData(filteredData);
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };


  const fetchData = async () => {
    try {
      if (deptData.length === 0) return;
      const response = await api.get(`/department-data-year?lang=${i18n.language}`);
      const filteredDepartments = response.data.filter(
        (department) =>
          department.status === 1 &&
          department.language_code === i18n.language
      );
      const filteredData = filteredDepartments.filter(
        (item) => item.y_id === deptData[0]?.y_id
      );
      setData(filteredData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDepartmentData = async () => {
    try {
      const response = await api.get(`/public_disclosure?lang=${i18n.language}`);
      const filteredDepartments = response.data.filter(
        (department) =>
          department.status === 1 &&
          department.language_code === i18n.language
      );
      setDepartmentName(filteredDepartments);
      const filteredData = filteredDepartments.filter(
        (item) => String(item.p_id) === String(deptData[0]?.p_id)
      );
      setDepartmentData(filteredData);
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  useEffect(() => {
    fetchDeptData();
    // eslint-disable-next-line
  }, [i18n.language]);

  useEffect(() => {
    if (deptData.length > 0) {
      fetchData();
      fetchDepartmentData();
    }
    // eslint-disable-next-line
  }, [deptData, i18n.language]);

  const groupedData = data.reduce((acc, item) => {
    const { year } = item;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(item);
    return acc;
  }, {});

  const sortedData = Object.entries(groupedData).sort(([yearA], [yearB]) => {
    const parseYear = (y) => {
      const devanagariToArabic = {
        '०': '0', '१': '1', '२': '2', '३': '3', '४': '4',
        '५': '5', '६': '6', '७': '7', '८': '8', '९': '9',
      };
      const normalized = y.replace(/[०१२३४५६७८९]/g, (digit) => devanagariToArabic[digit] || digit);
      const match = normalized.match(/\d{4}/g);
      return parseInt(match?.[0] || "0", 10);
    };

    return parseYear(yearB) - parseYear(yearA);
  });


  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${innerBanner})`,
          }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{departmentData[0]?.department_name}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/departments">{t("departments")}</Link>
              </li>
              <li>
                <span>{departmentData[0]?.department_name}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="departments-style-two faq-section alternat-2">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-9 col-md-12 col-sm-12 content-side">
              <div className="department-details-content">
                <div className="content-one dept_leyer_1">
                  <div className="title-box">
                    <h3>{deptData[0]?.department_heading}</h3>
                    <hr />
                  </div>
                </div>
              </div>
              <div className="row clearfix">
                <div className="col-lg-1 col-md-1 col-sm-1 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img src="assets/images/resource/faq-1.jpg" alt="" />
                    </figure>
                  </div>
                </div>
                <div className="col-lg-11 col-md-11 col-sm-11 content-column">
                  <div className="content-box">
                    <ul className="accordion-box year-accordion-box">
                      {sortedData.map(([year, records], index) => (
                        <li
                          key={index}
                          className={`accordion block ${activeIndex === index ? "active-block" : ""
                            }`}
                        >
                          <div
                            className="acc-btn"
                            onClick={() => handleAccordionClick(index)}
                          >
                            <span className="count-text">{index + 1}</span>
                            <h3>{year}</h3>
                          </div>
                          <div
                            className="acc-content"
                            style={{
                              display: activeIndex === index ? "block" : "none",
                            }}
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <ul>
                                  {records.map((record, idx) => (
                                    <li key={idx}>
                                      <Link
                                        to={record.pdf.startsWith("http") ? record.pdf : `${baseURL}/${record.pdf}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {record.pdfheading}
                                      </Link>
                                    </li>

                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 sidebar-side">
              <div className="department-sidebar">
                <div className="category-widget">
                  <div className="widget-content">
                    <ul className="category-list clearfix">
                      {departmentName.map((department, index) => (
                        <li key={index}>
                          <Link
                            to={
                              department?.department_name === "General Admin Department" || department?.department_name === "सामान्य प्रशासन विभाग"
                                ? "/general-admin-department"
                                  : `${department?.department_link}`
                            }
                            state={{ id: department?.p_id }}
                          >
                            {department?.department_name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeptDataYear;
